import { defineMessages } from '@redbubble/next/intl';

export const messages = defineMessages({
  filters: {
    defaultMessage: 'Filters',
  },
  viewResults: {
    defaultMessage: 'View results',
  },
  product: {
    defaultMessage: 'Products',
  },
  close: {
    defaultMessage: 'Close',
  },
});
